import { render } from "./BelongsToField.vue?vue&type=template&id=66d4d446"
import script from "./BelongsToField.vue?vue&type=script&lang=js"
export * from "./BelongsToField.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\systems\\nova-erp-system\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BelongsToField.vue"]])

export default __exports__